import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Gto } from '../../base/vo/gto';
import { ProcedimentoCancela } from '../../base/vo/procedimentoCancela';
import { AcoesService } from '../acoes.service';


@Component({
  selector: 'app-acao-cancelar-procedimento',

  templateUrl: './acao-cancelar-procedimento.component.html',
  styleUrls: ['./acao-cancelar-procedimento.component.css']
})
export class AcaoCancelarProcedimentoComponent implements OnInit {

  @Input() gto: Gto;
  @Input() numeroGTO: number;

  display = false;
  procedimentoCancela: ProcedimentoCancela;
  errorMsg = false;
  motivoCancelamento = '';
  cancelamentoSucesso: boolean;
  loading = false;
  numeroGtoRefresh: string = null;

  constructor(private acoesService: AcoesService, public router: Router) {
  }

  ngOnInit() {
    this.errorMsg = false;
  }

  abrirDialog(numeroGTO, linha) {
    this.procedimentoCancela = new ProcedimentoCancela();
    this.procedimentoCancela.linha = linha;
    this.procedimentoCancela.motivo = '';
    this.procedimentoCancela.numero = numeroGTO;
    this.numeroGtoRefresh = numeroGTO.toString();
    this.display = true;
  }

  onSubmit(form) {
    this.loading = true;
    if (form.control.invalid) {
      this.errorMsg = true;
      this.loading = false;
      return;
    }
    this.cancelar();
  }

  cancelar(): void {

    this.loading = true;
    this.procedimentoCancela.motivo = this.motivoCancelamento;

    this.acoesService.excluirProcedimento(this.procedimentoCancela)
      .subscribe(data => {
        this.loading = false;
        this.cancelamentoSucesso = true;
      },
        err => {
          console.log('Mensagem de erro');
          this.cancelamentoSucesso = false;
        });
    this.loading = false;
  }

  limpaErro() {
    this.errorMsg = false;
  }

  fecharDialog() {
    this.limpaErro();
    window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/acoes/acao-cancelar-procedimento/acao-cancelar-procedimento.component.ts